import isNil from "lodash/isNil";
import { useQuery } from "urql";

import {
  ImportType,
  LastImportDateDocument,
} from "../../../graphql/generated.ts";

interface Props {
  type: ImportType;
}

export function useLastImportDate({ type }: Props) {
  return useQuery({
    query: LastImportDateDocument,
    variables: { type },
    pause: isNil(type),
  });
}
